import React, { useEffect, useMemo, useState } from 'react'
import { parseUrl } from 'query-string'
import useScript from 'react-script-hook'

import WidgetPage from 'components/hocs/widget-page'

const SRC = '693761'
const INVENTORY_TYPE = 'auto-fox-zipwidget'

const QuinstreetWidget = () => {
  const { query } = parseUrl(window.location.href)

  const { snowplow } = global

  const [domainSessId, setDomainSessId] = useState(null)
  const [isWidgetLoaded, setWidgetLoaded] = useState(false)

  const containerId = 'quinstreet-widget-container'
  useEffect(() => {
    if (snowplow) {
      // eslint-disable-next-line func-names
      snowplow(function () {
        let domainSessIdTmp = null
        try {
          // eslint-disable-next-line react/no-this-in-sfc,prefer-destructuring
          domainSessIdTmp = this.default.getDomainUserInfo()[6]
          // eslint-disable-next-line react/no-this-in-sfc
          setDomainSessId(domainSessIdTmp)
        } catch (e) {
          console.error('Error getting domain user id', domainSessId, e)
        }
      })
    }
  }, [snowplow])

  const [scriptLoading, scriptError] = useScript({
    src: `https://www.nextinsure.com/listingdisplay/loader/sh`,
    charset: 'utf-8',
    type: 'text/javascript',
  })

  const config = useMemo(
    () => ({
      var1: query.var1,
      var2: domainSessId,
      var3: query.var3,
      src: SRC,
      inventorytype: INVENTORY_TYPE,
      trn_id: query.credsessid,
    }),
    [domainSessId],
  )

  useEffect(() => {
    if (isWidgetLoaded || !config.var2) {
      return
    }

    if (!scriptLoading && !scriptError) {
      window?.sh?.initialize(config, containerId)
      console.log('QS widget initialized', { config })
      setWidgetLoaded(true)
    }
  }, [scriptLoading, scriptError, config, isWidgetLoaded])

  return <div id={containerId} />
}

export default WidgetPage(QuinstreetWidget)
